import axios from "axios";
import UrlAPI from '../../components/UrlAPI'

export const LISTA_DE_NOTICIAS = "lista_de_noticias";
export const MAXIMO_DE_PAGINAS = "maximo_de_paginas";
export const PAGINA_ATUAL = "pagina_atual";
export const DETALHE_DO_POST = "detalhe_do_post";

export default class ValidadorApi {
  static getNewsList(page = 1, cb = () => {}, perPage = 12) {
    return dispatch => {
      axios.get(`${UrlAPI.getWordpressApiUrl()}/posts?_embed=true&per_page=${perPage}&page=${page}`)
        .then(res => {
          dispatch({type:LISTA_DE_NOTICIAS, payload:res.data});
          dispatch({type:PAGINA_ATUAL, payload:page});
          dispatch({type:MAXIMO_DE_PAGINAS, payload:res.headers["x-wp-totalpages"]});
          cb()
        })
    }
  }

  static resetList(page = 1, cb) {
    return dispatch => {
      dispatch({type: LISTA_DE_NOTICIAS, payload: undefined});
      dispatch({type: PAGINA_ATUAL, payload: undefined});
      dispatch({type: MAXIMO_DE_PAGINAS, payload: undefined});
    }
  }

  static getPostDetail(post = undefined){
    return dispatch => {
      if (post){
      axios.get(`${UrlAPI.getWordpressApiUrl()}/posts?slug=${post}&_embed`)
        .then(res => {
          dispatch({type:DETALHE_DO_POST, payload:res.data})
        })
      } else {
        dispatch({type:DETALHE_DO_POST, payload:post})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/logicas/Noticias/NoticiasApi.js